
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gbpRj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $932f144204fcf725$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $932f144204fcf725$export$2e2bcd8739ae039 = {
    'cross-flow-support.back-to-all-products': "\u3059\u3079\u3066\u306E\u30A2\u30D7\u30EA\u306B\u623B\u308B",
    'cross-flow-support.close': "\u9589\u3058\u308B",
    'cross-flow-support.product-store': "\u30A2\u30D7\u30EA \u30B9\u30C8\u30A2"
};

});


//# sourceMappingURL=ja.d027b0b8.js.map
